module.exports = __webpack_public_path__ + "static/media/certification.2dbca33d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/assets/images/certification.svg
// module id = 1849
// module chunks = 27